import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-info-button',
  templateUrl: './info-button.component.html',
  styleUrls: ['./info-button.component.scss'],
})
export class InfoButtonComponent {
  @Input() iconPath: string = '';
  @Input() tittle: string = '';
  @Input() info: string = '';

  @Input() fill: 'solid' | 'outline' | 'gray' = 'outline';
  constructor() { }

  ngOnInit() {}

  capitalizeWords(str: string): string {
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  

}
